import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SurveyComponent } from '../../../../models/SurveyTemplates';
import { Namespace } from '../../../../locales/translations';

interface YesNoFieldProps {
    field: SurveyComponent;
    value?: boolean | null;
    onChange?: (value: boolean | null) => void;
    disabled?: boolean;
}

const YesNoField: React.FC<YesNoFieldProps> = ({
    field,
    value = null,
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.SURVEY_BUILDER]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value === 'true' ? true : event.target.value === 'false' ? false : null;
        onChange?.(newValue);
    };

    return (
        <FormControl component="fieldset" fullWidth disabled={disabled}>
            <RadioGroup
                row
                value={value === null ? "" : value.toString()}
                onChange={handleChange}
            >
                <FormControlLabel 
                    value={true}
                    control={<Radio />} 
                    label={t('field_messages.yes_no.yes')}
                />
                <FormControlLabel 
                    value={false} 
                    control={<Radio />} 
                    label={t('field_messages.yes_no.no')}
                />
            </RadioGroup>
        </FormControl>
    );
};

export default YesNoField;
